export default __webpack_public_path__ + "static/media/file4.c9c3aead.png";